import { managerActions } from '@store/reducers/manager/actions'
import {
  createProjectAndSaveSaga,
  createProjectBoilerplateSaga,
  fetchProjectSaga,
  initEmptyProjectActionsSaga,
  initPreviewSaga,
  initProjectActionsSaga,
  openProjectSaga,
  refetchProjectAccessSaga,
  saveProjectSaga,
  touch,
} from '@store/reducers/manager/sagas'
import { projectUsersActions } from '@store/reducers/manager/users/actions'
import { fetchUsers } from '@store/reducers/manager/users/saga'
import { all, takeLatest } from 'redux-saga/effects'

function* managerSaga() {
  yield all([
    takeLatest(managerActions.previewInit, initPreviewSaga),
    takeLatest(managerActions.touch, touch),
    takeLatest(managerActions.fetchProjectSaga, fetchProjectSaga),
    // При смене проекта актуален только последний запрос — иначе поздний ответ
    // по старому проекту дописал бы чужих авторов
    takeLatest(projectUsersActions.fetchUsersSaga, fetchUsers),
    takeLatest(managerActions.openProjectSaga, openProjectSaga),
    takeLatest(
      managerActions.refetchProjectAccessSaga,
      refetchProjectAccessSaga
    ),
    takeLatest(managerActions.saveProjectSaga, saveProjectSaga),
    takeLatest(managerActions.initProjectActionsSaga, initProjectActionsSaga),
    takeLatest(
      managerActions.initEmptyProjectActionsSaga,
      initEmptyProjectActionsSaga
    ),
    takeLatest(
      managerActions.createProjectBoilerplateSaga,
      createProjectBoilerplateSaga
    ),
    takeLatest(
      managerActions.createProjectAndSaveSaga,
      createProjectAndSaveSaga
    ),
  ])
}

export default managerSaga
